import React from "react";
import { compose } from "redux";
import classnames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import MaterialDrawer from "@material-ui/core/Drawer";
import { colors } from "../../theme";
import { withDrawer } from "../common/wrappers/withDrawer";
import { withBreakpoint } from "../common/wrappers/withBreakpoint";
import { withMobile } from "../common/wrappers/withMobile";
import { CrossIcon } from "../common/Svg";
import * as drawers from "./Navbar/NavbarMenu";

const navbarHeight = 64;

const defaultOptions = {
  showCloseButton: true,
};

const useBackdropStyles = makeStyles({
  root: {
    backgroundColor: (props) =>
      props.isBelowSm && props.isMobile ? "transparent" : null,
  },
});

const useDrawerStyles = makeStyles({
  root: {},
  paper: {
    boxShadow: (props) => props.isMobile && "none",
    backgroundColor: (props) => {
      if (props.isMobile) return colors.background;
      if (props.backgroundColor) return props.backgroundColor;
      return null;
    },
    height: (props) => props.isBelowSm && `calc(100vh - ${navbarHeight}px)`,
    marginTop: (props) => props.isBelowSm && `${navbarHeight}px`,
  },
});

const Drawer = ({
  drawerContext,
  breakpointContext: { isBelow },
  mobileContext: { isMobile },
}) => {
  const { componentProps, options = {}, ...props } = drawerContext;
  const allProps = { ...componentProps, ...props };
  const { anchor = "right", width, backgroundColor } = componentProps;
  const { componentType, isOpen, closeDrawer } = props;
  const Component = drawers[componentType];

  const isBelowSm = isBelow("sm");

  const renderCloseButton = () => (
    <button
      type="button"
      className="absolute cursor-pointer z-10"
      style={{ right: 10, top: 10 }}
      onClick={closeDrawer}
    >
      <CrossIcon />
    </button>
  );

  return (
    <div>
      <MaterialDrawer
        variant="temporary"
        anchor={anchor}
        open={isOpen}
        onClose={closeDrawer}
        classes={useDrawerStyles({ isMobile, isBelowSm, backgroundColor })}
        BackdropProps={{ classes: useBackdropStyles({ isBelowSm, isMobile }) }}
      >
        <div
          className={classnames(
            isBelowSm ? "h-drawer-sm w-screen" : "h-auto w-drawer-lg"
          )}
          style={{ width }}
        >
          {Component && (
            <div className="relative">
              {(options.showCloseButton !== undefined
                ? options.showCloseButton
                : defaultOptions.showCloseButton) && renderCloseButton()}
              <Component {...allProps} />
            </div>
          )}
        </div>
      </MaterialDrawer>
    </div>
  );
};

export default compose(
  withDrawer,
  withBreakpoint,
  withMobile
)(Drawer);
